import { Activity, tSharedAppState } from 'common/modules/ReactShared';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IActivityResponse } from '../../../api/activity/types';

const initialState: IActivityResponse = {
  data: []
};

const getActivity = createAsyncThunk<
  Activity.ActivityApiTypes.IActivityResponse,
  {
    startDate: string;
    endDate: string;
  },
  { state: tSharedAppState }
>('activity/getActivity_request', async ({ startDate, endDate }) => {
  const data = await Activity.activityApi.getActivity({ startDate, endDate });

  return data;
});

const activitySlice = createSlice({
  name: 'activity',
  initialState: initialState as IActivityResponse,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getActivity.fulfilled, (_, action) => {
      return action.payload;
    });
  }
});

const { reducer } = activitySlice;

const actions = {
  getActivity
};

export { actions, reducer };
